import { jwtDecode } from 'jwt-decode';

// O token de acesso vive no localStorage (`authToken`) — mesma fonte usada pelo
// axios (attachAuthToken) e pelos hooks (useUser/useIsAdmin/useUserType). Não há
// cookie `token` legível (o refresh token é httpOnly), então ler de document.cookie
// retornava sempre null e derrubava o fluxo de "Minhas informações".
export const getUserIdFromToken = (): string | null => {
  const token = localStorage.getItem('authToken');
  if (!token) return null;

  try {
    const decodedToken = jwtDecode<{ sub?: string }>(token);
    return decodedToken.sub ?? null;
  } catch {
    return null;
  }
};
